import { ERentioFormField } from "@rentiohq/shared-frontend/dist/components/components/Form";
import { IUiSchema } from "@rentiohq/shared-frontend/dist/forms/forms.types";
import { getValue } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import {
  EBrokerFeature,
  EIntakeType,
} from "@rentiohq/shared-frontend/dist/types/broker.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { JSONSchema6 } from "json-schema";
import { EField, IExtraData } from "./schema.tenantProfileBroker.types";

// The order asked for on DEV-3065: one phase, two phases, two phases with the
// extra step. These ids are stored values, not positions, so reordering
// this list changes nothing about what any broker has saved, and the order is
// shared by every broker whether or not they have Rentmatch.
//
// Only the third label differs per broker. With the Rentmatch feature it names
// that flow's own step, without it the older schedule-for-visit step, and that
// second label is also used in Backoffice, so it stays exactly as it is.
const INTAKE_TYPE_OPTIONS = [
  { id: EIntakeType.OnePhase },
  { id: EIntakeType.TwoPhases },
  { id: EIntakeType.TwoPhasesWithVisit },
];

// Read in two places, the option labels and the field title below, so it lives
// here once instead of drifting apart.
const brokerHasRentMatch = (extraData: IExtraData) =>
  !!extraData.broker.features?.includes(EBrokerFeature.RentMatch);

export const getSchema =
  (initialValues: { [key: string]: any }, extraData: IExtraData) =>
  (defaultValues: { [key: string]: any }): JSONSchema6 => {
    const hasRentMatch = brokerHasRentMatch(extraData);
    return {
      required: [EField.IntakeMail, EField.IntakeType],
      properties: {
        [EField.IntakeType]: {
          default: getValue(EField.IntakeType, initialValues, defaultValues),
          //@ts-ignore
          options: INTAKE_TYPE_OPTIONS.map(type => ({
            id: type.id,
            value: getLocalizedText(
              type.id === 3 && hasRentMatch
                ? `broker.rentmatch.intakeType.${type.id}`
                : `broker.intakeType.${type.id}`,
            ),
          })),
        },
        [EField.IntakeMail]: {
          default: getValue(EField.IntakeMail, initialValues, defaultValues),
        },
      },
    };
  };

export const uiSchema = (extraData: IExtraData): IUiSchema<EField> => ({
  [EField.IntakeType]: {
    "ui:field": ERentioFormField.DropdownSelect,
    // Carries the product name, so it follows the same split as the labels
    // above and the banner on this screen (DEV-3065).
    title: getLocalizedText(
      brokerHasRentMatch(extraData)
        ? "broker.rentmatch.tenant_profile.intake_type.label"
        : "broker.tenant_profile.intake_type.label",
    ),
  },
  [EField.IntakeMail]: {
    "ui:field": ERentioFormField.Email,
    title: getLocalizedText("broker.tenant_profile.intake_email.label"),
  },
});
